export const tracker = {
  'tracker.trigger': 'Report an issue',
  'tracker.dialogTitle': 'Add issue',
  'tracker.foldWindow': 'Fold the report window',
  'tracker.unfoldWindow': 'Unfold the report window',
  'tracker.moveWindow': 'Move the report window',
  'tracker.description': 'Description',
  'tracker.charactersLeft': '{count} left',
  'tracker.context': 'Sent with the report automatically.',
  'tracker.module': 'Module',
  'tracker.screen': 'Screen',
  'tracker.agent': 'Assign to agent',
  'tracker.agentsLoading': 'Loading agent availability…',
  'tracker.agentsUnavailable': 'Agent availability is unavailable. The issue can still be created.',
  'tracker.agentFree': 'Free',
  'tracker.agentBusy': 'Busy',
  'tracker.agentOffline': 'Offline',
  'tracker.agentModel': 'Model: {model}',
  'tracker.agentCurrentWork': 'Current work: {summary}',
  'tracker.attachments': 'Attachments',
  'tracker.optional': 'Optional',
  'tracker.chooseAttachments': 'Choose attachments',
  'tracker.attachmentCountOne': '{count} attachment',
  'tracker.attachmentCountMany': '{count} attachments',
  // The position of one capture in the list. The full stop after the
  // number is punctuation a language chooses, not a character to weld
  // onto an index in TSX.
  'tracker.attachmentNumber': '{number}.',
  'tracker.attachmentOn': 'Added on {screen}',
  'tracker.removeAttachment': 'Remove attachment {number}',
  'tracker.attachmentLimit': 'Up to {count} supported files can be attached to one issue.',
  'tracker.unsavedIntent': 'Issue report \u2014 not yet submitted',
  'tracker.openIssues': 'Open issues',
  'tracker.opening': 'Opening issues',
  'tracker.popupBlocked': 'The issue tracker could not open in a new tab.',
  'tracker.cancel': 'Cancel',
  'tracker.submit': 'Create issue',
  'tracker.submitting': 'Creating issue',
  'tracker.created': 'Issue #{number} was created.',
  'tracker.createdDetail': 'Saved in the issue tracker.',
  'tracker.assignedAgent': 'Sent to {agent}.',
  'tracker.reportAnother': 'Report another',
  'tracker.close': 'Close',
  'tracker.attachmentWarning': 'The issue was created, but an attachment could not be uploaded.',
  'tracker.releaseCheckWarning': 'The follow-up issue was created, but the released task could not be marked checked. Use Mark checked on the Release tab to try again.',
  'tracker.dispatchWarning': 'The issue was created, but the agent assignment was not delivered.',
  'tracker.errorTooLarge': 'The attachments are too large together.',
  'tracker.errorUnsupported': 'Use PNG, JPEG, WebP, PDF, JSON, Markdown, or plain text files.',
  'tracker.errorForbidden': 'Your account cannot create issues.',
  'tracker.errorSignedOut': 'Your session has ended. Sign in again, then send this report.',
  'tracker.errorRefused': 'The report was refused as written. Edit it and try again.',
  'tracker.errorUnavailable': 'Creation could not be confirmed. Your report is still here. Try again to check or send it.',
  'tracker.errorChanged': 'An earlier attempt already created a report with different content. Check My reports before sending this one again.',
  'tracker.myReports': 'My reports',
  'tracker.openReport': 'Open report #{number}',
  'tracker.tabs': 'Issue reporter sections',
  'tracker.tabReport': 'Report',
  'tracker.tabRelease': 'Release',
  'tracker.release.title': 'Release verification',
  'tracker.release.subtitle': 'Closed tracker tasks that still need a manual check.',
  'tracker.release.includeChecked': 'Show checked',
  'tracker.release.loading': 'Loading release tasks',
  'tracker.release.empty': 'Nothing waiting for release verification',
  'tracker.release.emptyDetail': 'Closed tasks marked release/checked are hidden by default.',
  'tracker.release.listLabel': 'Release verification tasks',
  'tracker.release.noRelease': 'No release label',
  // The STATE a row is already in, and the ACTION that puts it there. They were
  // the same word, so a verified row read "Checked" beside a button offering to
  // check it.
  'tracker.release.checkedState': 'Verified',
  'tracker.release.check': 'Mark checked',
  'tracker.release.checking': 'Marking checked',
  'tracker.release.fix': 'Fix',
  'tracker.release.followUpFor': 'Follow-up',
  'tracker.release.followUpDraft': 'Follow-up for closed task #{number}: {title}',
  'tracker.release.errorChanged': 'This task changed in the tracker. Reload the Release tab and try again.',
  'tracker.release.errorNotClosed': 'Only closed tasks can be marked checked.',
  'tracker.release.errorGone': 'This task is no longer available in the release checklist.',

  // The reports workspace: the register.
  'tracker.reports.title': 'Reports',
  'tracker.reports.subtitle': 'Issue reports filed from this application.',
  'tracker.reports.tableLabel': 'Report register',
  'tracker.reports.scopeLabel': 'Scope',
  'tracker.reports.scopeMine': 'My reports',
  'tracker.reports.scopeAll': 'All reports',
  'tracker.reports.loading': 'Loading reports',
  'tracker.reports.loadFailed': 'Reports could not be loaded.',
  'tracker.reports.forbidden': 'Your account cannot open reports.',
  'tracker.reports.empty': 'No reports yet',
  'tracker.reports.emptyDetail': 'Reports filed from this application appear here.',
  'tracker.reports.columnNumber': 'Number',
  'tracker.reports.columnTitle': 'Title',
  'tracker.reports.columnReporter': 'Reporter',
  'tracker.reports.columnEnvironment': 'Environment',
  'tracker.reports.columnState': 'State',
  'tracker.reports.columnWork': 'Work',
  'tracker.reports.columnCreated': 'Created',
  'tracker.reports.columnUpdated': 'Updated',
  'tracker.reports.columnActions': 'Actions',
  'tracker.reports.openNamed': 'Open report #{number}',
  'tracker.reports.deleteNamed': 'Delete report #{number}',
  'tracker.reports.reload': 'Refresh the list',
  'tracker.reports.reloaded': 'The list was refreshed.',
  'tracker.reports.reloadFailed': 'The list could not be refreshed.',

  // The reports workspace: one report.
  'tracker.report.title': 'Report',
  'tracker.report.number': '#{number}',
  'tracker.report.back': 'Back to reports',
  'tracker.report.loading': 'Loading report',
  'tracker.report.loadFailed': 'The report could not be loaded.',
  'tracker.report.notFound': 'This report does not exist or was deleted.',
  'tracker.report.forbidden': 'Your account cannot open this report.',
  'tracker.report.state': 'State',
  'tracker.report.stateOpen': 'Open',
  'tracker.report.stateClosed': 'Closed',
  'tracker.report.work': 'Work',
  'tracker.report.started': 'Taken into work',
  'tracker.report.notStarted': 'Not started',
  'tracker.report.reporter': 'Reporter',
  'tracker.report.environment': 'Environment',
  'tracker.report.created': 'Created',
  'tracker.report.updated': 'Updated',
  'tracker.report.readOnlyNote': 'This report can no longer be changed by your account.',
  'tracker.report.readOnlyComments': 'Comments can still be added.',
  'tracker.report.description': 'Description',
  'tracker.report.noDescription': 'No description.',
  'tracker.report.attachments': 'Report attachments',
  'tracker.report.attachmentWarning': 'The change was saved, but an attachment could not be uploaded.',
  'tracker.report.comments': 'Comments',
  'tracker.report.noComments': 'No comments yet.',
  'tracker.report.commentEdited': 'Edited',
  'tracker.report.commentAttachments': 'Comment attachments',
  'tracker.report.commentLabel': 'New comment',
  'tracker.report.commentHint': 'Markdown. An image pasted into the field is attached.',
  'tracker.report.commentReadOnly': 'Comments can no longer be added to this report. Your draft is still here.',
  'tracker.report.send': 'Add comment',
  'tracker.report.sending': 'Adding comment',
  'tracker.report.commentAdded': 'Comment added.',
  'tracker.report.editDescription': 'Edit description',
  'tracker.report.editTitle': 'Edit title',
  'tracker.report.titleField': 'Title',
  'tracker.report.saveTitle': 'Save title',
  'tracker.report.savingTitle': 'Saving title',
  'tracker.report.titleSaved': 'Title saved.',
  'tracker.report.cancelTitle': 'Cancel title edit',
  'tracker.report.save': 'Save changes',
  'tracker.report.saving': 'Saving',
  'tracker.report.saved': 'Changes saved.',
  'tracker.report.close': 'Close report',
  'tracker.report.closing': 'Closing',
  'tracker.report.closeTitle': 'Close report #{number}?',
  'tracker.report.closeDescription': 'A closed report stays readable and open to comments, but it can no longer be edited here.',
  'tracker.report.closeConfirm': 'Close report',
  'tracker.report.closed': 'Report closed.',
  'tracker.report.delete': 'Delete report',
  'tracker.report.deleting': 'Deleting',
  'tracker.report.deleteTitle': 'Delete report #{number}?',
  'tracker.report.deleteDescription': 'The report and its comments are removed from the tracker. This cannot be undone.',
  'tracker.report.deleteConfirm': 'Delete',
  'tracker.report.deleted': 'Report #{number} was deleted.',
  'tracker.report.reload': 'Reload the report',
  'tracker.report.reloaded': 'The report was reloaded. Review it, then try again.',
  'tracker.report.reloadFailed': 'The report could not be reloaded.',
  'tracker.report.unsavedTitle': 'Report title \u2014 not yet saved',
  'tracker.report.unsavedDescription': 'Report description \u2014 not yet saved',
  'tracker.report.unsavedComment': 'Comment \u2014 not yet added',
  'tracker.report.errorChanged': 'The report changed since it was loaded. Reload it, then try again.',
  'tracker.report.errorReadOnly': 'The report was taken into work and can no longer be changed here.',
  'tracker.report.errorUncertain': 'The change could not be confirmed. Your draft is still here. Try again to check or send it.',
  'tracker.report.errorUnavailable': 'The tracker is not available right now. Your draft is still here. Try again later.',
  'tracker.report.errorForbidden': 'Your account cannot change this report.',
  'tracker.report.errorGone': 'This report no longer exists.',
  'tracker.report.errorRefused': 'The change was refused as written. Edit it and try again.',

  // The Markdown editor.
  'tracker.editor.tabs': 'Editor view',
  'tracker.editor.write': 'Write',
  'tracker.editor.preview': 'Preview',
  'tracker.editor.toolbar': 'Formatting',
  'tracker.editor.heading': 'Heading',
  'tracker.editor.bold': 'Bold',
  'tracker.editor.italic': 'Italic',
  'tracker.editor.strikethrough': 'Strikethrough',
  'tracker.editor.quote': 'Quote',
  'tracker.editor.code': 'Code',
  'tracker.editor.link': 'Link',
  'tracker.editor.bulletedList': 'Bulleted list',
  'tracker.editor.numberedList': 'Numbered list',
  'tracker.editor.taskList': 'Task list',
  'tracker.editor.nothingToPreview': 'Nothing to preview yet.',
} as const
